module.exports = __webpack_public_path__ + "bradavice_6_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_6_after_tn.jpg
// module id = 1407
// module chunks = 0